<div class="alert-info" fxLayout="row" fxLayoutAlign="space-around center" *ngFor="let info of infos; let i = index">
    <mat-card class="alert-card" [ngClass]="{ 'odd-card': isOdd(i), 'even-card': !isOdd(i) }">
        <mat-icon svgIcon="close-icon" class="close-icon" (click)="close(info)"></mat-icon>
        <div class="card-content">
            <div class="time-info">
                <span class="time">{{ info.time }}</span>
            </div>
            <!-- 急変リスク：複数のバイタルを表示 -->
            <div class="vital-list" *ngIf="info.acuteChangeVitals && info.acuteChangeVitals.length > 0">
                <div class="vital-item" *ngFor="let vital of info.acuteChangeVitals">
                    <div class="icon-container-left">
                        <mat-icon class="status-icon" [ngClass]="getIconBackgroundClass(vital.icon)" svgIcon="{{ vital.icon }}"></mat-icon>
                    </div>
                    <div class="detail-middle">
                        <div class="status-text">{{ getVitalText(vital.key) }}</div>
                    </div>
                    <div class="shape-container-right">
                        <div class="status-shape-checkbox" 
                             [ngClass]="'shape-' + vital.shape + ' state-' + vital.state"></div>
                    </div>
                </div>
            </div>
            <!-- その他のリスク（位置、睡眠、综合评估） -->
            <div class="icon-text" *ngIf="!info.acuteChangeVitals && (info.icon.length > 0 || (info.shape && info.state))">
                <div class="icon-container-left">
                    <mat-icon *ngIf="info.icon.length > 0" class="status-icon" [ngClass]="getIconBackgroundClass(info.icon)" svgIcon="{{ info.icon }}"></mat-icon>
                </div>
                <div class="detail-middle">
                    <div class="status-text">{{ info.text }}</div>
                    <div class="status-subtext">{{ info.subText }}</div>
                </div>
                <div class="shape-container-right">
                    <div *ngIf="info.shape && info.state" 
                         class="status-shape-checkbox" 
                         [ngClass]="'shape-' + info.shape + ' state-' + info.state"></div>
                </div>
            </div>
            <div class="name">{{ info.name }}</div>
            <div class="room">{{ info.room }}</div>
        </div>
    </mat-card>
</div>